import { FormControl, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps, GruppoLookup, TipoImpresa } from '../../types/types';
import { API_elaboraIForfetari } from '../../utils/functions';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             //minWidth: 320,
//             border: '1px solid black'
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         select: {
//             width: "10rem",
//         },
//     }),
// );

export default function RegimeForfettario(props: DefaultInputProps) {
    const [global] = useGlobal<IGlobalState>();
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeRegimeForfettario";
    const { state } = props;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    };

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraIForfetari(props, global, name, value, action, true);
    };

    const handleBlur = (e: any) => {
        // API_elaboraIForfetari(props, global);
    }

    let warnJ52 = ((state.tipologia.valueOf() === TipoImpresa.Impresa.valueOf() && state.regimeForfettario.gruppo === 8) || (state.tipologia.valueOf() === TipoImpresa.Professione.valueOf() && state.regimeForfettario.gruppo !== 8));

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionSubTitle text="Regime forfetario"></SectionSubTitle>
            <Grid container>
                <Grid item md={4} xs={12}>     
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="gruppo">Gruppo</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.regimeForfettario.gruppo}
                            onChange={handleChangeSelect}
                            inputProps={{
                                name: 'gruppo',
                                id: 'gruppo',
                            }}
                        >
                            {GruppoLookup.map(g => {
                                return (
                                    <MenuItem value={g.codice} key={g.codice}>{g.descrizione}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>     
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="imposta">% Imposta Sostitutiva</InputLabel>
                    <Select
                        className={gClasses.selectIForf}
                        value={state.regimeForfettario.impostaSost}
                        onChange={handleChangeSelect}
                        inputProps={{
                            name: 'impostaSost',
                            id: 'impostaSost'
                        }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={15}>15</MenuItem>
                    </Select>
                </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>     
                <NumberField
                    name="percRedd"
                    label="% Redditività"
                    value={state.regimeForfettario.percentualeRedditivita}
                    onChange={handleChange} onBlur={handleBlur}
                    className={gClasses.textFieldReadOnly}
                    symbol={"%"}
                    readOnly={true}                    
                />
                {warnJ52 ? <Typography variant="subtitle1" color="error">Possibile incompatibilità con la tipologia. Le attività rappresentate da alcuni codici Ateco previsti in 
questo Gruppo possono essere esercitate sia come impresa, sia come professione. Se è il tuo caso, prosegui con la simulazione, 
altrimenti correggi”</Typography> : <p></p>}
                </Grid>
            </Grid>
        </Paper>
    );
}